import Airline from "../models/Airline";

const airlinesList: Airline[] = [
  {
    name: "12 North",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEWSV8v1yhJgK",
    iata_code: "12",
    conditions_of_carriage_url: null,
  },
  {
    name: "1Time Airline",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAGiJjwomhv2w",
    iata_code: "1T",
    conditions_of_carriage_url: null,
  },
  {
    name: "40-Mile Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/Q5.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/Q5.svg",
    id: "arl_00009VME7DAGiJjwomhv2x",
    iata_code: "Q5",
    conditions_of_carriage_url: null,
  },
  {
    name: "ABSA - Aerolinhas Brasileiras",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAGiJjwomhv38",
    iata_code: "M3",
    conditions_of_carriage_url: null,
  },
  {
    name: "Abu Dhabi Amiri Flight",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/MO.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/MO.svg",
    id: "arl_00009VME7DAyfgJ6qz2U9R",
    iata_code: "MO",
    conditions_of_carriage_url:
      "https://www.calmair.com/before-you-fly/passenger-rights",
  },
  {
    name: "Ada Air",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAGiJjwomhv3F",
    iata_code: "ZY",
    conditions_of_carriage_url: null,
  },
  {
    name: "Adam Air",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAyfgJ6qz2UA9",
    iata_code: "KI",
    conditions_of_carriage_url: null,
  },
  {
    name: "Adria Airways",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAGiJjwomhv3H",
    iata_code: "JP",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aegean Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/A3.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/A3.svg",
    id: "arl_00009VME7DAGiJjwomhv3K",
    iata_code: "A3",
    conditions_of_carriage_url:
      "https://en.aegeanair.com/conditions-notices/conditions-notices/",
  },
  {
    name: "Aer Arann",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5Clhu",
    iata_code: "RE",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aer Lingus",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EI.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/EI.svg",
    id: "arl_00009VME7DAyfgJ6qz2UAH",
    iata_code: "EI",
    conditions_of_carriage_url:
      "https://www.aerlingus.com/support/legal/conditions-of-carriage/",
  },
  {
    name: "Aer Lingus UK",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EG.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/EG.svg",
    id: "arl_0000ACxYBmXgp0rX9ogi3c",
    iata_code: "EG",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aero Benin",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EM.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/EM.svg",
    id: "arl_00009VME7DAGiJjwomhv3J",
    iata_code: "EM",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aerocondor",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/2B.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/2B.svg",
    id: "arl_00009VME7DAch01WpssCcJ",
    iata_code: "2B",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aero Condor Peru",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/Q6.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/Q6.svg",
    id: "arl_00009VME7DAyfgJ6qz2UA1",
    iata_code: "Q6",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aero Contractors",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AJ.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AJ.svg",
    id: "arl_00009VME7DBKeMags5Clhm",
    iata_code: "AJ",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aero Flight",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/GV.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/GV.svg",
    id: "arl_00009VME7DAch01WpssCcG",
    iata_code: "GV",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aeroflot",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/SU.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/SU.svg",
    id: "arl_00009VME7DAch01WpssCbG",
    iata_code: "SU",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aeroflot-Don",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAyfgJ6qz2UAD",
    iata_code: "D9",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aero Lanka",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QL.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QL.svg",
    id: "arl_00009VME7DBKeMags5Clhz",
    iata_code: "QL",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aerolineas Argentinas",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AR.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AR.svg",
    id: "arl_00009VME7DAch01WpssCcL",
    iata_code: "AR",
    conditions_of_carriage_url:
      "https://www.aerolineas.com.ar/legales?tab=condicionestransporte",
  },
  {
    name: "Aerolitoral",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCbO",
    iata_code: "5D",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aeromar",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/VW.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/VW.svg",
    id: "arl_00009VME7DBKeMags5CliC",
    iata_code: "VW",
    conditions_of_carriage_url:
      "https://www.aeromar.mx/es/terminos-y-condiciones",
  },
  {
    name: "Aeromexico",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AM.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AM.svg",
    id: "arl_00009VME7DAch01WpssCbz",
    iata_code: "AM",
    conditions_of_carriage_url:
      "https://aeromexico.com/en-us/legal-information",
  },
  {
    name: "Aeropelican Air Services",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/OT.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/OT.svg",
    id: "arl_00009VME7DBKeMags5Clho",
    iata_code: "OT",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aeroper",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/PL.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/PL.svg",
    id: "arl_00009VME7DAch01WpssCbR",
    iata_code: "PL",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aeropostal Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/VH.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/VH.svg",
    id: "arl_0000AOnLULhHSZlbzXx8dq",
    iata_code: "VH",
    conditions_of_carriage_url:
      "https://www.vivaair.com/co/en/legal-information_terms-and-conditions",
  },
  {
    name: "Aerosur",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5Cli5",
    iata_code: "5L",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aerosvit Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/VV.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/VV.svg",
    id: "arl_00009VME7DAch01WpssCbB",
    iata_code: "VV",
    conditions_of_carriage_url: null,
  },
  {
    name: "AeroWorld ",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/W4.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/W4.svg",
    id: "arl_00009VME7DEWSV8v1yhJg9",
    iata_code: "W4",
    conditions_of_carriage_url: null,
  },
  {
    name: "Africa West",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAyfgJ6qz2U9v",
    iata_code: "FK",
    conditions_of_carriage_url: null,
  },
  {
    name: "Afriqiyah Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/8U.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/8U.svg",
    id: "arl_00009VME7DAGiJjwomhv35",
    iata_code: "8U",
    conditions_of_carriage_url: "https://afriqiyah.aero/en/",
  },
  {
    name: "Aigle Azur",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAGiJjwomhv30",
    iata_code: "ZI",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Afrique",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5Clhx",
    iata_code: "RK",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Algerie",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AH.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AH.svg",
    id: "arl_00009VME7DAyfgJ6qz2UA8",
    iata_code: "AH",
    conditions_of_carriage_url:
      "https://airalgerie.dz/en/legal-notice/general-conditions-of-carriage-2/",
  },
  {
    name: "Air Antilles",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/3S.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/3S.svg",
    id: "arl_0000AOYusDGN6avbDqLldQ",
    iata_code: "3S",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Arabia",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/G9.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/G9.svg",
    id: "arl_00009VME7DAch01WpssCc3",
    iata_code: "G9",
    conditions_of_carriage_url: null,
  },
  {
    name: "AirAsia",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AK.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AK.svg",
    id: "arl_00009VME7DAyfgJ6qz2U9g",
    iata_code: "AK",
    conditions_of_carriage_url: null,
  },
  {
    name: "AirAsia X",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/D7.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/D7.svg",
    id: "arl_00009VME7DC2bj9quHXKp6",
    iata_code: "D7",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Astana",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/KC.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/KC.svg",
    id: "arl_00009VME7DAyfgJ6qz2UAh",
    iata_code: "KC",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Atlanta Icelandic",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/CC.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/CC.svg",
    id: "arl_00009VME7DAch01WpssCbf",
    iata_code: "CC",
    conditions_of_carriage_url:
      "https://www.cmairlines.com/wp-content/uploads/2019/12/C-2-2019-11-Package-policies-EN.pdf",
  },
  {
    name: "Air Austral",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/UU.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/UU.svg",
    id: "arl_00009VME7DBKeMags5Clhv",
    iata_code: "UU",
    conditions_of_carriage_url:
      "https://www.air-austral.com/en/general-conditions-of-carriage.html",
  },
  {
    name: "Air Bagan",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAyfgJ6qz2UAc",
    iata_code: "W9",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Baltic",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/BT.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/BT.svg",
    id: "arl_00009VME7DAch01WpssCc5",
    iata_code: "BT",
    conditions_of_carriage_url:
      "https://www.airbaltic.com/en-GB/general-conditions-of-carriage",
  },
  {
    name: "Air Bangladesh",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/B9.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/B9.svg",
    id: "arl_00009VME7DAyfgJ6qz2U9Y",
    iata_code: "B9",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Belgium",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/KF.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/KF.svg",
    id: "arl_0000AOtmcer4giohSyoIkg",
    iata_code: "KF",
    conditions_of_carriage_url:
      "https://www.airbelgium.com/en/legal/general-terms-and-conditions-of-carriage/",
  },
  {
    name: "Air Berlin",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCbb",
    iata_code: "AB",
    conditions_of_carriage_url: null,
  },
  {
    name: "Airblue",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCba",
    iata_code: "ED",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Bosna",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/JA.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/JA.svg",
    id: "arl_00009VME7DAch01WpssCbH",
    iata_code: "JA",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Botswana",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/BP.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/BP.svg",
    id: "arl_00009VME7DAyfgJ6qz2U9r",
    iata_code: "BP",
    conditions_of_carriage_url:
      "https://www.airbotswana.co.bw/general-conditions-carriage",
  },
  {
    name: "Air Bourbon",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/ZB.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/ZB.svg",
    id: "arl_00009VME7DAch01WpssCbe",
    iata_code: "ZB",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Burkina",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/2J.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/2J.svg",
    id: "arl_00009VME7DAch01WpssCcT",
    iata_code: "2J",
    conditions_of_carriage_url:
      "https://air-burkina.com/en/general-conditions-of-carriage#:~:text=The%20passenger%20is%20required%20to,departure%20formalities%20to%20be%20completed.",
  },
  {
    name: "Air Busan",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/BX.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/BX.svg",
    id: "arl_00009VME7DEATorL0sX285",
    iata_code: "BX",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aircalin",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/SB.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/SB.svg",
    id: "arl_00009VME7DAch01WpssCbJ",
    iata_code: "SB",
    conditions_of_carriage_url:
      "https://www.aircalin.pf/en/general-terms-conditions-sale-transport",
  },
  {
    name: "Air Canada",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AC.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AC.svg",
    id: "arl_00009VME7DAch01WpssCc4",
    iata_code: "AC",
    conditions_of_carriage_url:
      "https://www.aircanada.com/us/en/aco/home/legal/conditions-carriage-tariffs.html#/",
  },
  {
    name: "Air Canada Jazz",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAyfgJ6qz2UAe",
    iata_code: "QK",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Canada Rouge",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009v2FtJonDdBD44Funw",
    iata_code: "RV",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Caraïbes",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/TX.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/TX.svg",
    id: "arl_00009VME7DAyfgJ6qz2U9c",
    iata_code: "TX",
    conditions_of_carriage_url:
      "https://en.aircaraibes.com/en/general-conditions-sale-and-carriage",
  },
  {
    name: "Air Cargo Carriers",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCbL",
    iata_code: "2Q",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Chathams",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/3C.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/3C.svg",
    id: "arl_00009VME7DAyfgJ6qz2UA5",
    iata_code: "3C",
    conditions_of_carriage_url:
      "https://www.airchathams.co.nz/terms-and-conditions",
  },
  {
    name: "Air China",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/CA.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/CA.svg",
    id: "arl_00009VME7DAyfgJ6qz2UA0",
    iata_code: "CA",
    conditions_of_carriage_url:
      "https://www.airchina.co.uk/GB/GB/General-Conditions-of-Carriage-for-Passengers-and-Baggage",
  },
  {
    name: "Air Choice One",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/3E.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/3E.svg",
    id: "arl_0000AOnLULgvTtU1yRmr56",
    iata_code: "3E",
    conditions_of_carriage_url:
      "https://www.airchoiceone.com/sites/default/files/2019-12/Contract%20of%20Carriage%20Rev%2012-2019-2%20FINAL.pdf",
  },
  {
    name: "Aircompany Armenia",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/RM.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/RM.svg",
    id: "arl_0000APtpnoH6pyM0gu3z7o",
    iata_code: "RM",
    conditions_of_carriage_url:
      "https://armeniafly.com/conditions-of-carriage-en",
  },
  {
    name: "Air Corsica",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/XK.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/XK.svg",
    id: "arl_00009VME7DBgd2sGtBN3H0",
    iata_code: "XK",
    conditions_of_carriage_url:
      "https://www.aircorsica.com/flights/conditions-carriage-passengers.html",
  },
  {
    name: "Air Creebec",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/YN.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/YN.svg",
    id: "arl_0000AOnLULhHSZlbzXx8dt",
    iata_code: "YN",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Do",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/HD.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/HD.svg",
    id: "arl_00009VME7DCOaPRQvNhcMo",
    iata_code: "HD",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Dolomiti",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EN.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/EN.svg",
    id: "arl_00009VME7DAyfgJ6qz2UAC",
    iata_code: "EN",
    conditions_of_carriage_url:
      "https://www.airdolomiti.eu/legal-info/air-carrier-liability",
  },
  {
    name: "Air Europa",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/UX.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/UX.svg",
    id: "arl_00009VME7DAGiJjwomhv3I",
    iata_code: "UX",
    conditions_of_carriage_url:
      "https://www.aireuropa.com/uk/en/aea/travel-information/terms-and-conditions/conditions-of-carriage.html",
  },
  {
    name: "Air Europa",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000APtp6OplYCXLKpZeOu",
    iata_code: "X5",
    conditions_of_carriage_url:
      "https://www.aireuropa.com/uk/en/aea/travel-information/terms-and-conditions/conditions-of-carriage.html",
  },
  {
    name: "Air Europe",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/PE.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/PE.svg",
    id: "arl_00009VME7DAGiJjwomhv3M",
    iata_code: "PE",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Exel",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/XT.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/XT.svg",
    id: "arl_00009VME7DAyfgJ6qz2U9f",
    iata_code: "XT",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Finland",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/OF.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/OF.svg",
    id: "arl_00009VME7DAyfgJ6qz2UAL",
    iata_code: "OF",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Florida",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QH.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QH.svg",
    id: "arl_00009VME7DAyfgJ6qz2UAO",
    iata_code: "QH",
    conditions_of_carriage_url:
      "https://www.bambooairways.com/global-en/terms-and-conditions/conditions-of-carriage/",
  },
  {
    name: "Air France",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AF.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AF.svg",
    id: "arl_00009VME7DAch01WpssCbI",
    iata_code: "AF",
    conditions_of_carriage_url:
      "https://wwws.airfrance.co.uk/information/legal/edito-cg-airfrance",
  },
  {
    name: "Air Glaciers",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCbQ",
    iata_code: "7T",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Greenland",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/GL.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/GL.svg",
    id: "arl_00009VME7DAyfgJ6qz2UAV",
    iata_code: "GL",
    conditions_of_carriage_url:
      "https://as-agl-web-prod.azurewebsites.net/media/5hkdqc4p/provisions-of-carriage-air-greenland.pdf",
  },
  {
    name: "Air Guinee Express",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAyfgJ6qz2UAS",
    iata_code: "2U",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Hamburg (AHO)",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/HH.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/HH.svg",
    id: "arl_00009VME7DEATorL0sX291",
    iata_code: "HH",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Iceland Connect",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/NY.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/NY.svg",
    id: "arl_00009VME7DAyfgJ6qz2UAP",
    iata_code: "NY",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air India",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AI.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AI.svg",
    id: "arl_00009VME7DAch01WpssCbd",
    iata_code: "AI",
    conditions_of_carriage_url: "https://www.airindia.in/terms-conditions.htm",
  },
  {
    name: "Air India Express",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/IX.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/IX.svg",
    id: "arl_00009VME7DAyfgJ6qz2U9d",
    iata_code: "IX",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Indus",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEWSV8v1yhJgO",
    iata_code: "PP",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Inuit",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/3H.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/3H.svg",
    id: "arl_0000AOnLULhHSZlbzXx8dM",
    iata_code: "3H",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Italy",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCbC",
    iata_code: "I9",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Italy",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DCkZ5j0wTrtvk",
    iata_code: "IG",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Ivoire",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAyfgJ6qz2U9q",
    iata_code: "VU",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Japan",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCbp",
    iata_code: "NQ",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Kazakhstan",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/9Y.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/9Y.svg",
    id: "arl_00009VME7DEATorL0sX289",
    iata_code: "9Y",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Koryo",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/JS.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/JS.svg",
    id: "arl_00009VME7DAyfgJ6qz2UAg",
    iata_code: "JS",
    conditions_of_carriage_url: null,
  },
  {
    name: "Airlinair",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5Clhy",
    iata_code: "A5",
    conditions_of_carriage_url: null,
  },
  {
    name: "Airlines Of Tasmania",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/FO.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/FO.svg",
    id: "arl_00009VME7DAch01WpssCcU",
    iata_code: "FO",
    conditions_of_carriage_url: null,
  },
  {
    name: "Airlink",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/4Z.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/4Z.svg",
    id: "arl_0000A8HCIZSfGF7PTABhC4",
    iata_code: "4Z",
    conditions_of_carriage_url:
      "https://www.flyairlink.com/en/za/conditions-of-carriage",
  },
  {
    name: "Air Luxor",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/LK.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/LK.svg",
    id: "arl_00009VME7DAyfgJ6qz2UAo",
    iata_code: "LK",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Macau",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/NX.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/NX.svg",
    id: "arl_00009VME7DAch01WpssCbw",
    iata_code: "NX",
    conditions_of_carriage_url: "http://www.airmacau.com.mo/",
  },
  {
    name: "Air Madagascar",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/MD.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/MD.svg",
    id: "arl_00009VME7DAyfgJ6qz2UAq",
    iata_code: "MD",
    conditions_of_carriage_url:
      "https://madagascarairlines.com/en/informations/general-conditions-of-sale-and-carriage.html",
  },
  {
    name: "Air Madrid",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAyfgJ6qz2UAE",
    iata_code: "NM",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Malawi",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QM.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QM.svg",
    id: "arl_00009VME7DAch01WpssCbv",
    iata_code: "QM",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Malta",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/KM.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/KM.svg",
    id: "arl_00009VME7DAch01WpssCbn",
    iata_code: "KM",
    conditions_of_carriage_url:
      "https://airmalta.com/en-gb/legal-and-policies/general-conditions-of-carriage",
  },
  {
    name: "Air Marshall Islands",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/CW.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/CW.svg",
    id: "arl_00009VME7DAyfgJ6qz2UA6",
    iata_code: "CW",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Mauritius",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/MK.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/MK.svg",
    id: "arl_00009VME7DAyfgJ6qz2UAp",
    iata_code: "MK",
    conditions_of_carriage_url:
      "https://www.airmauritius.com/conditions-of-carriage",
  },
  {
    name: "Air Mediterranee",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/DR.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/DR.svg",
    id: "arl_00009VME7DAyfgJ6qz2U9Z",
    iata_code: "DR",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Mekong",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/P8.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/P8.svg",
    id: "arl_00009VME7DEATorL0sX290",
    iata_code: "P8",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Moldova",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/9U.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/9U.svg",
    id: "arl_00009VME7DBKeMags5Clhg",
    iata_code: "9U",
    conditions_of_carriage_url:
      "https://www.airmoldova.md/terms-of-carriage-en/",
  },
  {
    name: "Air Namibia",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/SW.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/SW.svg",
    id: "arl_00009VME7DAch01WpssCbN",
    iata_code: "SW",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air New Zealand",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/NZ.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/NZ.svg",
    id: "arl_00009VME7DAch01WpssCcA",
    iata_code: "NZ",
    conditions_of_carriage_url:
      "https://www.airnewzealand.co.uk/conditions-of-carriage",
  },
  {
    name: "Air Nippon",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EL.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/EL.svg",
    id: "arl_00009VME7DAch01WpssCc6",
    iata_code: "EL",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Niugini",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/PX.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/PX.svg",
    id: "arl_00009VME7DAch01WpssCc2",
    iata_code: "PX",
    conditions_of_carriage_url:
      "https://www.airniugini.com.pg/conditions-of-carriage/",
  },
  {
    name: "Airnorth",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/TL.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/TL.svg",
    id: "arl_00009VME7DAch01WpssCc7",
    iata_code: "TL",
    conditions_of_carriage_url:
      "https://www.airnorth.com.au/plan/fare-information/conditions-of-carriage/",
  },
  {
    name: "Air North",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/4N.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/4N.svg",
    id: "arl_00009VME7DAch01WpssCc8",
    iata_code: "4N",
    conditions_of_carriage_url: "https://www.flyairnorth.com/support",
  },
  {
    name: "Air Nostrum",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCc1",
    iata_code: "YW",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Nostrum for Iberia",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000A4zpmTvai3p7GykWf2",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "Air One",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AP.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AP.svg",
    id: "arl_00009VME7DAch01WpssCbl",
    iata_code: "AP",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Plus Comet",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/A7.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/A7.svg",
    id: "arl_00009VME7DBKeMags5Clhi",
    iata_code: "A7",
    conditions_of_carriage_url: null,
  },
  {
    name: "AirRussia",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEWSV8v1yhJgF",
    iata_code: "R8",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Sahara",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCbm",
    iata_code: "S2",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Salone",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5Cli0",
    iata_code: "20",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Senegal",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/HC.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/HC.svg",
    id: "arl_0000AOtmceqii2X7Rse1Cg",
    iata_code: "HC",
    conditions_of_carriage_url:
      "https://flyairsenegal.com/en/legal-notice/conditions-of-carriage/",
  },
  {
    name: "Air Serbia",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/JU.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/JU.svg",
    id: "arl_00009VME7DCOaPRQvNhcNQ",
    iata_code: "JU",
    conditions_of_carriage_url:
      "https://www.airserbia.com/en/footer_copy_menu/legal/general-conditions-of-carriage",
  },
  {
    name: "Air Seychelles",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/HM.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/HM.svg",
    id: "arl_00009VME7DAch01WpssCby",
    iata_code: "HM",
    conditions_of_carriage_url:
      "https://www.airseychelles.com/en/conditions-of-carriage",
  },
  {
    name: "Air Sinai",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCcO",
    iata_code: "4D",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Tahiti",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/VT.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/VT.svg",
    id: "arl_00009VME7DAyfgJ6qz2U9t",
    iata_code: "VT",
    conditions_of_carriage_url:
      "https://www.airtahitinui.com/uk-en/conditions-carriage",
  },
  {
    name: "Air Tahiti Nui",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/TN.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/TN.svg",
    id: "arl_00009VME7DAch01WpssCbh",
    iata_code: "TN",
    conditions_of_carriage_url:
      "https://www.airtahitinui.com/uk-en/conditions-carriage",
  },
  {
    name: "Air Tanzania",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/TC.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/TC.svg",
    id: "arl_00009VME7DAch01WpssCcS",
    iata_code: "TC",
    conditions_of_carriage_url: "https://www.airtanzania.co.tz/",
  },
  {
    name: "AirTran Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/FL.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/FL.svg",
    id: "arl_00009VME7DBKeMags5CliH",
    iata_code: "FL",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Transat",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/TS.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/TS.svg",
    id: "arl_00009VME7DBKeMags5CliI",
    iata_code: "TS",
    conditions_of_carriage_url:
      "https://www.airtransat.com/en-GB/legal-notice-uk/general-terms-and-conditions",
  },
  {
    name: "Air Vanuatu",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/NF.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/NF.svg",
    id: "arl_00009VME7DAyfgJ6qz2U9X",
    iata_code: "NF",
    conditions_of_carriage_url:
      "https://www.airvanuatu.com/travel-info/conditions-of-carriage",
  },
  {
    name: "Air Wakanda",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAGiJjwomhv2v",
    iata_code: "D1",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Wales",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/6G.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/6G.svg",
    id: "arl_00009VME7DAyfgJ6qz2U9b",
    iata_code: "6G",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Wisconsin",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCbs",
    iata_code: "ZW",
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Wisconsin as American Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000ARZRCqmThus81Oo3o8",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Wisconsin as United Express",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009khl3rsLx6wSUxjK0e",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "Air Zimbabwe",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/UM.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/UM.svg",
    id: "arl_00009VME7DAyfgJ6qz2U9l",
    iata_code: "UM",
    conditions_of_carriage_url: null,
  },
  {
    name: "Alaska Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AS.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AS.svg",
    id: "arl_00009VME7DAch01WpssCcN",
    iata_code: "AS",
    conditions_of_carriage_url:
      "https://www.alaskaair.com/content/legal/contract-of-carriage/rule-1",
  },
  {
    name: "Alaska Central Express",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/KO.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/KO.svg",
    id: "arl_00009VME7DAGiJjwomhv3N",
    iata_code: "KO",
    conditions_of_carriage_url: null,
  },
  {
    name: "Albanian Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/LV.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/LV.svg",
    id: "arl_00009VME7DAyfgJ6qz2UAi",
    iata_code: "LV",
    conditions_of_carriage_url:
      "https://www.flylevel.com/en/about-us/conditions-of-carriage",
  },
  {
    name: "Alitalia CityLiner",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000A87372pXOrxxuciSki",
    iata_code: "CT",
    conditions_of_carriage_url: null,
  },
  {
    name: "Alitalia Express",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCcE",
    iata_code: "XM",
    conditions_of_carriage_url: null,
  },
  {
    name: "Allegiant Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/G4.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/G4.svg",
    id: "arl_00009VME7DAGiJjwomhv36",
    iata_code: "G4",
    conditions_of_carriage_url: null,
  },
  {
    name: "Alliance Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QQ.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QQ.svg",
    id: "arl_00009VME7DAch01WpssCbE",
    iata_code: "QQ",
    conditions_of_carriage_url: null,
  },
  {
    name: "AlMasria Universal Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/UJ.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/UJ.svg",
    id: "arl_00009VME7DEATorL0sX28Z",
    iata_code: "UJ",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aloha Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAGiJjwomhv31",
    iata_code: "AQ",
    conditions_of_carriage_url: null,
  },
  {
    name: "ALROSA",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/6R.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/6R.svg",
    id: "arl_00009VME7DBKeMags5CliO",
    iata_code: "6R",
    conditions_of_carriage_url: null,
  },
  {
    name: "American Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AA.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AA.svg",
    id: "arl_00009VME7DAGiJjwomhv32",
    iata_code: "AA",
    conditions_of_carriage_url:
      "https://www.aa.com/i18n/customer-service/support/conditions-of-carriage.jsp",
  },
  {
    name: "American Eagle Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAyfgJ6qz2U9p",
    iata_code: "MQ",
    conditions_of_carriage_url: null,
  },
  {
    name: "America West Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/HP.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/HP.svg",
    id: "arl_00009VME7DAch01WpssCbr",
    iata_code: "HP",
    conditions_of_carriage_url: null,
  },
  {
    name: "Amsterdam Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEATorL0sX28c",
    iata_code: "WD",
    conditions_of_carriage_url: null,
  },
  {
    name: "ANA",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/NH.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/NH.svg",
    id: "arl_00009VME7DAch01WpssCc0",
    iata_code: "NH",
    conditions_of_carriage_url:
      "https://www.ana.co.jp/en/gb/siteinfo/international/conditions-of-carriage/",
  },
  {
    name: "ANA Wings",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000AOtJ117NufbYDt4mAa",
    iata_code: "EH",
    conditions_of_carriage_url: null,
  },
  {
    name: "Animawings",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000A84XgWwzotHKcBA6aG",
    iata_code: "A2",
    conditions_of_carriage_url: null,
  },
  {
    name: "Ansett Australia",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAGiJjwomhv2y",
    iata_code: "AN",
    conditions_of_carriage_url: null,
  },
  {
    name: "APG Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/GP.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/GP.svg",
    id: "arl_0000AOtmceqii2X7Rse1Cd",
    iata_code: "GP",
    conditions_of_carriage_url:
      "https://back-apgairlines.orchestra-platform.com/admin/TS/fckUserFiles/Content_File/carriage_conditions_APGAirlines_EN.pdf",
  },
  {
    name: "Ariana Afghan Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/FG.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/FG.svg",
    id: "arl_00009VME7DAch01WpssCbF",
    iata_code: "FG",
    conditions_of_carriage_url: null,
  },
  {
    name: "Arkia",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/IZ.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/IZ.svg",
    id: "arl_00009VME7DAch01WpssCbj",
    iata_code: "IZ",
    conditions_of_carriage_url:
      "http://docs.arkia.co.il/fliti/general_terms_eng.htm",
  },
  {
    name: "Armavia",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/U8.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/U8.svg",
    id: "arl_00009VME7DBKeMags5Cli1",
    iata_code: "U8",
    conditions_of_carriage_url: null,
  },
  {
    name: "Arrow Air",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCcH",
    iata_code: "JW",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aserca Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAyfgJ6qz2U9m",
    iata_code: "R7",
    conditions_of_carriage_url: null,
  },
  {
    name: "Asgard Airways",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAGiJjwomhv2u",
    iata_code: "D4",
    conditions_of_carriage_url: null,
  },
  {
    name: "Asiana Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/OZ.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/OZ.svg",
    id: "arl_00009VME7DAGiJjwomhv33",
    iata_code: "OZ",
    conditions_of_carriage_url:
      "https://flyasiana.com/C/GB/EN/contents/terms-of-transportation-and-notification",
  },
  {
    name: "Asian Spirit",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5Clhw",
    iata_code: "6K",
    conditions_of_carriage_url: null,
  },
  {
    name: "Asian Wings Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AW.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AW.svg",
    id: "arl_00009VME7DEWSV8v1yhJgL",
    iata_code: "AW",
    conditions_of_carriage_url: null,
  },
  {
    name: "Askari Aviation",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAGiJjwomhv34",
    iata_code: "4K",
    conditions_of_carriage_url: null,
  },
  {
    name: "ASKY",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/KP.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/KP.svg",
    id: "arl_00009zkEKxVQFkKSsT9q1g",
    iata_code: "KP",
    conditions_of_carriage_url: "https://www.flyasky.com/aa/en/plan",
  },
  {
    name: "ASL Airlines France",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/5O.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/5O.svg",
    id: "arl_00009w8ZaCFoHHsAahwGSO",
    iata_code: "5O",
    conditions_of_carriage_url:
      "https://www.aslairlines.fr/wp-content/uploads/2013/04/190219-GAL-CONDITIONS-OF-CARRIAGE-2019-1.pdf",
  },
  {
    name: "ASL Airlines IRL for Aer Lingus",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAyfgJ6qz2UJP",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "Astraeus",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCbA",
    iata_code: "5W",
    conditions_of_carriage_url: null,
  },
  {
    name: "Astrakhan Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/OB.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/OB.svg",
    id: "arl_00009VME7DAch01WpssCcR",
    iata_code: "OB",
    conditions_of_carriage_url:
      "https://www.boa.bo/content/docs/contrato_transporte_en.pdf",
  },
  {
    name: "Astral Aviation",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/8V.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/8V.svg",
    id: "arl_00009VME7DAGiJjwomhv3C",
    iata_code: "8V",
    conditions_of_carriage_url: null,
  },
  {
    name: "Atifly",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/A1.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/A1.svg",
    id: "arl_00009VME7DEATorL0sX28R",
    iata_code: "A1",
    conditions_of_carriage_url: null,
  },
  {
    name: "Atlantic Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/RC.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/RC.svg",
    id: "arl_00009VME7DAyfgJ6qz2UAN",
    iata_code: "RC",
    conditions_of_carriage_url:
      "https://www.atlanticairways.com/media/1523/iata_conditions-of-contract_en.pdf",
  },
  {
    name: "Atlant-Soyuz Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAyfgJ6qz2U9i",
    iata_code: "3G",
    conditions_of_carriage_url: null,
  },
  {
    name: "Atlas Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/5Y.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/5Y.svg",
    id: "arl_00009VME7DAyfgJ6qz2UAX",
    iata_code: "5Y",
    conditions_of_carriage_url: null,
  },
  {
    name: "Atlas Blue",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCbS",
    iata_code: "8A",
    conditions_of_carriage_url: null,
  },
  {
    name: "Atlasjet",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAyfgJ6qz2UAf",
    iata_code: "KK",
    conditions_of_carriage_url: null,
  },
  {
    name: "ATRAN",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/V8.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/V8.svg",
    id: "arl_00009VME7DAyfgJ6qz2U9x",
    iata_code: "V8",
    conditions_of_carriage_url: null,
  },
  {
    name: "Augsburg Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/IQ.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/IQ.svg",
    id: "arl_00009VME7DAch01WpssCcX",
    iata_code: "IQ",
    conditions_of_carriage_url: null,
  },
  {
    name: "AUOS",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEWSV8v1yhJg1",
    iata_code: "AU",
    conditions_of_carriage_url: null,
  },
  {
    name: "Aurigny Air Services",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/GR.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/GR.svg",
    id: "arl_00009VME7DAyfgJ6qz2U9T",
    iata_code: "GR",
    conditions_of_carriage_url:
      "https://www.aurigny.com/legal/conditions-carriage",
  },
  {
    name: "Austrian",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/OS.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/OS.svg",
    id: "arl_00009VME7DAch01WpssCcW",
    iata_code: "OS",
    conditions_of_carriage_url:
      "https://www.austrian.com/at/en/conditions-of-carriage",
  },
  {
    name: "Austrian Arrows",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5CliK",
    iata_code: "VO",
    conditions_of_carriage_url: null,
  },
  {
    name: "Avialeasing Aviation Company",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5CliJ",
    iata_code: "EC",
    conditions_of_carriage_url: null,
  },
  {
    name: "Avianca",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AV.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AV.svg",
    id: "arl_00009VME7DAyfgJ6qz2U9W",
    iata_code: "AV",
    conditions_of_carriage_url:
      "https://www.avianca.com/uk/en/sobre-nosotros/informacion-legal/contrato-transporte/",
  },
  {
    name: "Avianca Argentina",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000ARlQW0uC2PY4M9UnI0",
    iata_code: "A0",
    conditions_of_carriage_url:
      "https://www.avianca.com/uk/en/about-us/legal-documentation/contract-of-carriage/",
  },
  {
    name: "Avianca Cargo",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DDoV8ZkzmMkZx",
    iata_code: "QT",
    conditions_of_carriage_url: null,
  },
  {
    name: "Avianca Costa Rica",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DCkZ5j0wTrtuq",
    iata_code: "LR",
    conditions_of_carriage_url:
      "https://www.avianca.com/uk/en/sobre-nosotros/informacion-legal/contrato-transporte/",
  },
  {
    name: "Avianca Ecuador",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5CliN",
    iata_code: "2K",
    conditions_of_carriage_url:
      "avianca.com/otr/en/about-us/legal-documentation/contract-of-carriage/",
  },
  {
    name: "Avianca El Salvador",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DC2bj9quHXKpc",
    iata_code: "TA",
    conditions_of_carriage_url:
      "https://www.avianca.com/uk/en/sobre-nosotros/informacion-legal/contrato-transporte/",
  },
  {
    name: "Avient Aviation",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/Z3.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/Z3.svg",
    id: "arl_00009VME7DBKeMags5Cli8",
    iata_code: "Z3",
    conditions_of_carriage_url: null,
  },
  {
    name: "Avies",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCbX",
    iata_code: "U3",
    conditions_of_carriage_url: null,
  },
  {
    name: "Avior Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/9V.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/9V.svg",
    id: "arl_00009VME7DBKeMags5Cl18",
    iata_code: "9V",
    conditions_of_carriage_url: "https://aviorair.com/en/legal",
  },
  {
    name: "Aws express",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/B0.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/B0.svg",
    id: "arl_00009VME7DEWSV8v1yhJgU",
    iata_code: "B0",
    conditions_of_carriage_url:
      "https://www.lacompagnie.com/en/legal/conditions-of-carriage/",
  },
  {
    name: "Azerbaijan Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/J2.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/J2.svg",
    id: "arl_00009VME7DAch01WpssCbW",
    iata_code: "J2",
    conditions_of_carriage_url:
      "https://www.azal.az/en/information/rules-and-conditions",
  },
  {
    name: "Azores Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/S4.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/S4.svg",
    id: "arl_00009VME7DDSWSIAygCT1O",
    iata_code: "S4",
    conditions_of_carriage_url:
      "https://www.azoresairlines.pt/en/information/customer-commitment/general-conditions-of-carriage",
  },
  {
    name: "Azul Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AD.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AD.svg",
    id: "arl_0000AHfbp6fmwbZGuADYNk",
    iata_code: "AD",
    conditions_of_carriage_url:
      "https://www.voeazul.com.br/en/for-your-trip/international-flights/contract-of-carriage",
  },
  {
    name: "Azur Air Ukraine",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QU.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QU.svg",
    id: "arl_0000AOtmcer4giohSyoIl1",
    iata_code: "QU",
    conditions_of_carriage_url: null,
  },
  {
    name: "BA CityFlyer",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/CJ.svg",
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3Gg",
    iata_code: "CJ",
    conditions_of_carriage_url: null,
  },
  {
    name: "BA Euroflyer as British Airways",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000ASAcwbiaeJNpvowsJU",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "Bahamasair",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/UP.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/UP.svg",
    id: "arl_00009VME7DBKeMags5CliZ",
    iata_code: "UP",
    conditions_of_carriage_url:
      "https://www.bahamasair.com/other-policies-forms/conditions-of-carriage",
  },
  {
    name: "Baltic Air lines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEATorL0sX28K",
    iata_code: "B1",
    conditions_of_carriage_url: null,
  },
  {
    name: "Bamboo Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QH.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QH.svg",
    id: "arl_0000AOtmcer4giohSyoIl0",
    iata_code: "QH",
    conditions_of_carriage_url:
      "https://www.bambooairways.com/global-en/terms-and-conditions/conditions-of-carriage/",
  },
  {
    name: "Bangkok Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/PG.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/PG.svg",
    id: "arl_00009VME7DBKeMags5Clic",
    iata_code: "PG",
    conditions_of_carriage_url:
      "https://www.bangkokair.com/conditions/conditions-of-carriage",
  },

  {
    name: "Barents AirLink",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/8N.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/8N.svg",
    id: "arl_00009VME7DBKeMags5Clj3",
    iata_code: "8N",
    conditions_of_carriage_url: null,
  },
  {
    name: "Batik Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/ID.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/ID.svg",
    id: "arl_0000APtos3jfCIQXqSsixs",
    iata_code: "ID",
    conditions_of_carriage_url: "https://www.batikair.com/en/Terms",
  },
  {
    name: "Bearskin Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5Clie",
    iata_code: "JV",
    conditions_of_carriage_url: null,
  },
  {
    name: "Beijing Capital Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/JD.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/JD.svg",
    id: "arl_0000AOtmcer4giohSyoIka",
    iata_code: "JD",
    conditions_of_carriage_url:
      "https://intl.jdair.net/news/index?id=73&valueMenuaid=75",
  },
  {
    name: "Belair Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5CliY",
    iata_code: "4T",
    conditions_of_carriage_url: null,
  },
  {
    name: "Belavia",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/B2.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/B2.svg",
    id: "arl_00009VME7DBKeMags5Clio",
    iata_code: "B2",
    conditions_of_carriage_url: null,
  },
  {
    name: "Bellview Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/B3.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/B3.svg",
    id: "arl_00009VME7DBKeMags5Clif",
    iata_code: "B3",
    conditions_of_carriage_url: null,
  },
  {
    name: "Bemidji Aviation Services",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5Clii",
    iata_code: "CH",
    conditions_of_carriage_url: null,
  },
  {
    name: "Bering Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/8E.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/8E.svg",
    id: "arl_00009VME7DBKeMags5Clin",
    iata_code: "8E",
    conditions_of_carriage_url: null,
  },
  {
    name: "Berjaya Air",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5Cliu",
    iata_code: "J8",
    conditions_of_carriage_url: null,
  },
  {
    name: "Biman Bangladesh Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/BG.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/BG.svg",
    id: "arl_00009VME7DBKeMags5CliR",
    iata_code: "BG",
    conditions_of_carriage_url:
      "https://www.biman-airlines.com/termsConditions#Carriage-for-Passengers-and-Baggage",
  },
  {
    name: "Binter Canarias",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/NT.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/NT.svg",
    id: "arl_0000AOWZIbUr2d7EbRNpvE",
    iata_code: "NT",
    conditions_of_carriage_url:
      "https://www.bintercanarias.com/eng/information/contract-of-carriage",
  },
  {
    name: "Black Stallion Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/BZ.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/BZ.svg",
    id: "arl_00009VME7DEATorL0sX28z",
    iata_code: "BZ",
    conditions_of_carriage_url: null,
  },
  {
    name: "Blue1",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/KF.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/KF.svg",
    id: "arl_00009VME7DBKeMags5Clid",
    iata_code: "KF",
    conditions_of_carriage_url:
      "https://www.airbelgium.com/en/legal/general-terms-and-conditions-of-carriage/",
  },
  {
    name: "Blue Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/0B.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/0B.svg",
    id: "arl_00009VME7DBKeMags5Clj0",
    iata_code: "0B",
    conditions_of_carriage_url: null,
  },
  {
    name: "Blue Wings",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QW.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QW.svg",
    id: "arl_00009VME7DBKeMags5Cliv",
    iata_code: "QW",
    conditions_of_carriage_url: null,
  },
  {
    name: "bmi",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5Clig",
    iata_code: "BD",
    conditions_of_carriage_url: null,
  },
  {
    name: "bmibaby",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5Clih",
    iata_code: "WW",
    conditions_of_carriage_url: null,
  },
  {
    name: "Boliviana de Aviación",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/OB.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/OB.svg",
    id: "arl_0000AOtmcer4giohSyoIkv",
    iata_code: "OB",
    conditions_of_carriage_url:
      "https://www.boa.bo/content/docs/contrato_transporte_en.pdf",
  },
  {
    name: "Boutique Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/4B.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/4B.svg",
    id: "arl_0000AOnLULhHSZlbzXx8dO",
    iata_code: "4B",
    conditions_of_carriage_url: "https://www.boutiqueair.com/pages/terms",
  },
  {
    name: "BRAZIL AIR",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEATorL0sX28o",
    iata_code: "GB",
    conditions_of_carriage_url: null,
  },
  {
    name: "Brit Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/DB.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/DB.svg",
    id: "arl_00009VME7DBKeMags5Clix",
    iata_code: "DB",
    conditions_of_carriage_url: null,
  },
  {
    name: "British Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/BA.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/BA.svg",
    id: "arl_00009VME7DBKeMags5CliQ",
    iata_code: "BA",
    conditions_of_carriage_url:
      "https://www.britishairways.com/en-gb/information/legal/british-airways/general-conditions-of-carriage",
  },
  {
    name: "British International Helicopters",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/BS.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/BS.svg",
    id: "arl_00009VME7DBKeMags5Clia",
    iata_code: "BS",
    conditions_of_carriage_url: null,
  },
  {
    name: "British Mediterranean Airways",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5Clj1",
    iata_code: "KJ",
    conditions_of_carriage_url: null,
  },
  {
    name: "Brussels Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/SN.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/SN.svg",
    id: "arl_00009VME7DBKeMags5Cliz",
    iata_code: "SN",
    conditions_of_carriage_url:
      "https://www.brusselsairlines.com/de/en/legal-notices/terms-and-conditions-conditions-of-carriage",
  },
  {
    name: "Bulgaria Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/FB.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/FB.svg",
    id: "arl_00009VME7DBKeMags5Clj2",
    iata_code: "FB",
    conditions_of_carriage_url:
      "https://www.air.bg/en/customer-support/general-conditions-of-carriage/",
  },
  {
    name: "Buraq Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/UZ.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/UZ.svg",
    id: "arl_00009VME7DC2bj9quHXKoP",
    iata_code: "UZ",
    conditions_of_carriage_url: null,
  },
  {
    name: "Cabo Verde Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/VR.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/VR.svg",
    id: "arl_00009VME7DDoV8ZkzmMka0",
    iata_code: "VR",
    conditions_of_carriage_url:
      "https://caboverdeairlines.com/general-terms-and-conditions/",
  },
  {
    name: "CAL Cargo Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5Clj4",
    iata_code: "5C",
    conditions_of_carriage_url: null,
  },
  {
    name: "Calima Aviacion",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBKeMags5Clj5",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "Calm Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/MO.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/MO.svg",
    id: "arl_00009VME7DBgd2sGtBN3Fw",
    iata_code: "MO",
    conditions_of_carriage_url:
      "https://www.calmair.com/before-you-fly/passenger-rights",
  },
  {
    name: "Camair-Co",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QC.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QC.svg",
    id: "arl_0000AOtmcer4giohSyoIky",
    iata_code: "QC",
    conditions_of_carriage_url: "https://www.camair-co.cm/",
  },
  {
    name: "Cambodia Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/KR.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/KR.svg",
    id: "arl_0000AOtmcer4giohSyoIki",
    iata_code: "KR",
    conditions_of_carriage_url: null,
  },
  {
    name: "Cambodia Angkor Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/K6.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/K6.svg",
    id: "arl_0000AOtmcer4giohSyoIkf",
    iata_code: "K6",
    conditions_of_carriage_url:
      "https://www.cambodiaangkorair.com/post-category/34/terms-and-conditions",
  },
  {
    name: "Canadian Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3G0",
    iata_code: "CP",
    conditions_of_carriage_url: null,
  },
  {
    name: "Canadian National Airways",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEATorL0sX28M",
    iata_code: "CN",
    conditions_of_carriage_url: null,
  },
  {
    name: "Canadian North",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/5T.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/5T.svg",
    id: "arl_00009VME7DBgd2sGtBN3G1",
    iata_code: "5T",
    conditions_of_carriage_url: null,
  },
  {
    name: "CanXpress",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEATorL0sX28S",
    iata_code: "C1",
    conditions_of_carriage_url: null,
  },
  {
    name: "Cape Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/9K.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/9K.svg",
    id: "arl_00009VME7DBgd2sGtBN3G3",
    iata_code: "9K",
    conditions_of_carriage_url: null,
  },
  {
    name: "Caribbean Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/BW.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/BW.svg",
    id: "arl_00009VME7DBgd2sGtBN3G9",
    iata_code: "BW",
    conditions_of_carriage_url:
      "https://www.caribbean-airlines.com/#/legal-and-privacy/general-conditions-of-carriage",
  },
  {
    name: "Carpatair",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3GB",
    iata_code: "V3",
    conditions_of_carriage_url: null,
  },
  {
    name: "Cathay Dragon",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DC2bj9quHXKoD",
    iata_code: "KA",
    conditions_of_carriage_url: null,
  },
  {
    name: "Cathay Pacific",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/CX.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/CX.svg",
    id: "arl_00009VME7DBgd2sGtBN3GD",
    iata_code: "CX",
    conditions_of_carriage_url:
      "https://www.cathaypacific.com/content/dam/cx/legal-and-privacy/general-conditions-of-carriage-for-passengers-baggage-en.pdf",
  },
  {
    name: "Cayman Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/KX.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/KX.svg",
    id: "arl_00009VME7DBgd2sGtBN3GE",
    iata_code: "KX",
    conditions_of_carriage_url:
      "https://www.caymanairways.com/contract-of-carriage",
  },
  {
    name: "Cebgo",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DDSWSIAygCT1o",
    iata_code: "DG",
    conditions_of_carriage_url: null,
  },
  {
    name: "Cebu Pacific",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/5J.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/5J.svg",
    id: "arl_00009VME7DBgd2sGtBN3GF",
    iata_code: "5J",
    conditions_of_carriage_url: null,
  },
  {
    name: "CemAir",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/5Z.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/5Z.svg",
    id: "arl_0000AOjBUkTDdDZs42M6vg",
    iata_code: "5Z",
    conditions_of_carriage_url:
      "https://www.flycemair.co.za/general_r/extras_and_info.php",
  },
  {
    name: "Central Mountain Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/9M.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/9M.svg",
    id: "arl_0000AOnLULhHSZlbzXx8da",
    iata_code: "9M",
    conditions_of_carriage_url: null,
  },
  {
    name: "Centralwings",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3GG",
    iata_code: "C0",
    conditions_of_carriage_url: null,
  },
  {
    name: "Chair Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/GM.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/GM.svg",
    id: "arl_0000AOtmceqii2X7Rse1Cc",
    iata_code: "GM",
    conditions_of_carriage_url: null,
  },
  {
    name: "Chalair Aviation",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/CE.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/CE.svg",
    id: "arl_0000AOtmceqii2X7Rse1CV",
    iata_code: "CE",
    conditions_of_carriage_url: null,
  },
  {
    name: "Chautauqua Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3GN",
    iata_code: "RP",
    conditions_of_carriage_url: null,
  },
  {
    name: "China Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/CI.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/CI.svg",
    id: "arl_00009VME7DBgd2sGtBN3GP",
    iata_code: "CI",
    conditions_of_carriage_url:
      "https://www.china-airlines.com/us/en/terms-and-conditions/transportation-clauses",
  },
  {
    name: "China Eastern Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/MU.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/MU.svg",
    id: "arl_00009VME7DBgd2sGtBN3GR",
    iata_code: "MU",
    conditions_of_carriage_url:
      "https://uk.ceair.com/newCMS/uk/en/content/en_Footer/AboutUS/201904/t20190404_5758.html",
  },
  {
    name: "China Southern Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/CZ.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/CZ.svg",
    id: "arl_00009VME7DBgd2sGtBN3GV",
    iata_code: "CZ",
    conditions_of_carriage_url:
      "https://www.csair.com/cn/tourguide/booking/orders/order/gjysztj/",
  },
  {
    name: "Chongqing Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEATorL0sX28j",
    iata_code: "OQ",
    conditions_of_carriage_url: null,
  },
  {
    name: "Cimber Air",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3Gb",
    iata_code: "QI",
    conditions_of_carriage_url: null,
  },
  {
    name: "Cirrus Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3Gc",
    iata_code: "C9",
    conditions_of_carriage_url: null,
  },
  {
    name: "City Airline",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3Gd",
    iata_code: "CF",
    conditions_of_carriage_url: null,
  },
  {
    name: "CityJet",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/WX.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/WX.svg",
    id: "arl_00009VME7DBgd2sGtBN3Gf",
    iata_code: "WX",
    conditions_of_carriage_url: "https://www.cityjet.com/terms-and-conditions/",
  },
  {
    name: "CM Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/CC.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/CC.svg",
    id: "arl_0000AOtmceqii2X7Rse1CU",
    iata_code: "CC",
    conditions_of_carriage_url:
      "https://www.cmairlines.com/wp-content/uploads/2019/12/C-2-2019-11-Package-policies-EN.pdf",
  },
  {
    name: "Colgan Air",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3Gk",
    iata_code: "9L",
    conditions_of_carriage_url: null,
  },
  {
    name: "Comair",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3Gl",
    iata_code: "OH",
    conditions_of_carriage_url: null,
  },
  {
    name: "Comair as British Airways",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009zkCNzEm4WdxCxgdof",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "CommutAir",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3Gn",
    iata_code: "C5",
    conditions_of_carriage_url: null,
  },
  {
    name: "Commutair as United Express",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009khl2Q2VxdarsPnALw",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "Comores Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/KR.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/KR.svg",
    id: "arl_00009VME7DBgd2sGtBN3Go",
    iata_code: "KR",
    conditions_of_carriage_url: null,
  },
  {
    name: "Compagnie Africaine d'Aviation",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/BU.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/BU.svg",
    id: "arl_0000AOtmceqii2X7Rse1CR",
    iata_code: "BU",
    conditions_of_carriage_url: null,
  },
  {
    name: "Compass Airlines as American Eagle",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009khkz3OxfiMgnVgdpA",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "Condor",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/DE.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/DE.svg",
    id: "arl_00009VME7DBgd2sGtBN3Gr",
    iata_code: "DE",
    conditions_of_carriage_url:
      "https://www.condor.com/eu/help-contact/gtbc.jsp",
  },
  {
    name: "Consorcio Aviaxsa",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3Gs",
    iata_code: "6A",
    conditions_of_carriage_url: null,
  },
  {
    name: "Contact Air",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3Gt",
    iata_code: "C3",
    conditions_of_carriage_url: null,
  },
  {
    name: "Continental Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3Gu",
    iata_code: "CO",
    conditions_of_carriage_url: null,
  },
  {
    name: "Continental Micronesia",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3Gw",
    iata_code: "CS",
    conditions_of_carriage_url: null,
  },
  {
    name: "Contour Aviation",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/LF.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/LF.svg",
    id: "arl_0000AOtmcer4giohSyoIkk",
    iata_code: "LF",
    conditions_of_carriage_url:
      "https://www.contourairlines.com/images//pdf/ContractOfCarriage2022.pdf",
  },
  {
    name: "Conviasa",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/V0.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/V0.svg",
    id: "arl_00009VME7DBgd2sGtBN3Gx",
    iata_code: "V0",
    conditions_of_carriage_url: null,
  },
  {
    name: "Copa Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/CM.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/CM.svg",
    id: "arl_00009VME7DBgd2sGtBN3Gy",
    iata_code: "CM",
    conditions_of_carriage_url:
      "https://www.copaair.com/en/web/us/contract-of-carriage",
  },
  {
    name: "Copa Airlines Colombia",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/P5.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/P5.svg",
    id: "arl_00009VME7DBKeMags5Cli3",
    iata_code: "P5",
    conditions_of_carriage_url: null,
  },
  {
    name: "Copenhagen Express",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEWSV8v1yhJgN",
    iata_code: "0X",
    conditions_of_carriage_url: null,
  },
  {
    name: "Corsair",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/SS.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/SS.svg",
    id: "arl_00009VME7DBgd2sGtBN3Gz",
    iata_code: "SS",
    conditions_of_carriage_url:
      "https://www.flycorsair.com/en/legal/general-sale-and-transport-conditions",
  },
  {
    name: "Croatia Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/OU.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/OU.svg",
    id: "arl_00009VME7DBgd2sGtBN3H2",
    iata_code: "OU",
    conditions_of_carriage_url:
      "https://www.croatiaairlines.com/Legal-information/General-conditions-of-carriage",
  },
  {
    name: "Cubana de Aviación",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/CU.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/CU.svg",
    id: "arl_00009VME7DBgd2sGtBN3H4",
    iata_code: "CU",
    conditions_of_carriage_url: null,
  },
  {
    name: "Cyprus Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/CY.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/CY.svg",
    id: "arl_00009VME7DBgd2sGtBN3H5",
    iata_code: "CY",
    conditions_of_carriage_url: "https://www.cyprusairways.com/info/rules.dot",
  },
  {
    name: "Czech Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/OK.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/OK.svg",
    id: "arl_00009VME7DBgd2sGtBN3H6",
    iata_code: "OK",
    conditions_of_carriage_url:
      "https://www.csa.cz/gb-en/travel-information/before-the-flight/conditions-of-carriage/",
  },
  {
    name: "Daallo Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/D3.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/D3.svg",
    id: "arl_00009VME7DBgd2sGtBN3HA",
    iata_code: "D3",
    conditions_of_carriage_url: null,
  },
  {
    name: "Dalavia",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3HC",
    iata_code: "H8",
    conditions_of_carriage_url: null,
  },
  {
    name: "Darwin Airline",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3HD",
    iata_code: "0D",
    conditions_of_carriage_url: null,
  },
  {
    name: "DAT",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/DX.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/DX.svg",
    id: "arl_00009VME7DBgd2sGtBN3H8",
    iata_code: "DX",
    conditions_of_carriage_url: null,
  },
  {
    name: "Delta Air Lines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/DL.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/DL.svg",
    id: "arl_00009VME7DBgd2sGtBN3HF",
    iata_code: "DL",
    conditions_of_carriage_url:
      "https://www.delta.com/gb/en/legal/contract-of-carriage-igr",
  },
  {
    name: "Dennis Sky",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEATorL0sX28Q",
    iata_code: "DH",
    conditions_of_carriage_url: null,
  },
  {
    name: "Domenican Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEATorL0sX28v",
    iata_code: "D1",
    conditions_of_carriage_url: null,
  },
  {
    name: "Domodedovo Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3HM",
    iata_code: "E3",
    conditions_of_carriage_url: null,
  },
  {
    name: "Drukair - Royal Bhutan Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/KB.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/KB.svg",
    id: "arl_00009VME7DC2bj9quHXKoE",
    iata_code: "KB",
    conditions_of_carriage_url: null,
  },
  {
    name: "Duffel Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/ZZ.svg",
    logo_lockup_url: null,
    id: "arl_00009VME7D6ivUu8dn35WK",
    iata_code: "ZZ",
    conditions_of_carriage_url: null,
  },
  {
    name: "Eastar Jet",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/ZE.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/ZE.svg",
    id: "arl_00009VME7DEATorL0sX28I",
    iata_code: "ZE",
    conditions_of_carriage_url: null,
  },
  {
    name: "Eastern Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/2D.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/2D.svg",
    id: "arl_0000AOzL72uKC7lez0n9dI",
    iata_code: "2D",
    conditions_of_carriage_url:
      "https://iflyea.com/contract-of-carriage/?v=2069589015",
  },
  {
    name: "Eastern Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/T3.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/T3.svg",
    id: "arl_00009VME7DC2bj9quHXKoK",
    iata_code: "T3",
    conditions_of_carriage_url:
      "https://www.easternairways.com/en-gb/information/travel-information/conditions-of-carriage/",
  },
  {
    name: "Eastern Australia as QantasLink",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000A7RiQ2V4q0YUBVblM8",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "easyJet",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/U2.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/U2.svg",
    id: "arl_00009VME7DC2bj9quHXKop",
    iata_code: "U2",
    conditions_of_carriage_url:
      "https://www.easyjet.com/en/terms-and-conditions",
  },
  {
    name: "Edelweiss Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/WK.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/WK.svg",
    id: "arl_00009VME7DC2bj9quHXKoM",
    iata_code: "WK",
    conditions_of_carriage_url: null,
  },
  {
    name: "EgyptAir",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/MS.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/MS.svg",
    id: "arl_00009VME7DC2bj9quHXKoN",
    iata_code: "MS",
    conditions_of_carriage_url:
      "https://www.egyptair.com/en/Pages/Conditions-of-Carriage.aspx",
  },
  {
    name: "EL AL",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/LY.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/LY.svg",
    id: "arl_00009VME7DC2bj9quHXKoO",
    iata_code: "LY",
    conditions_of_carriage_url:
      "https://www.elal.com/en/About-ELAL/Legal/Pages/Conditions-of-Carriage.aspx",
  },
  {
    name: "Emerald Airlines for Aer Lingus",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000AOUFafGbNNnK6o8E8u",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "Emirates",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EK.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/EK.svg",
    id: "arl_00009VME7DC2bj9quHXKoQ",
    iata_code: "EK",
    conditions_of_carriage_url:
      "https://www.emirates.com/uk/english/before-you-fly/travel/rules-and-notices/",
  },
  {
    name: "Empresa Ecuatoriana De Aviacion",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EU.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/EU.svg",
    id: "arl_00009VME7DC2bj9quHXKoS",
    iata_code: "EU",
    conditions_of_carriage_url: null,
  },
  {
    name: "Endeavor Air",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009v2RLSEecIX8m2yFjU",
    iata_code: "9E",
    conditions_of_carriage_url: null,
  },
  {
    name: "Endeavor Air as Delta Connection",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009v2RT5L3d7hi4sbXsm",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "Envoy Air as American Eagle",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009khkyWFEwpyrxnsuae",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "Epic Holiday",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/FA.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/FA.svg",
    id: "arl_00009VME7DEATorL0sX28N",
    iata_code: "FA",
    conditions_of_carriage_url:
      "https://www.flysafair.co.za/about-us/legal-ts-cs/terms-of-booking-carriage",
  },
  {
    name: "Era Alaska",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEWSV8v1yhJgE",
    iata_code: "7H",
    conditions_of_carriage_url: null,
  },
  {
    name: "Eritrean Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/B8.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/B8.svg",
    id: "arl_00009VME7DC2bj9quHXKoV",
    iata_code: "B8",
    conditions_of_carriage_url: null,
  },
  {
    name: "Estonian Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/OV.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/OV.svg",
    id: "arl_00009VME7DC2bj9quHXKoW",
    iata_code: "OV",
    conditions_of_carriage_url: null,
  },
  {
    name: "Ethiopian Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/ET.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/ET.svg",
    id: "arl_00009VME7DC2bj9quHXKoX",
    iata_code: "ET",
    conditions_of_carriage_url:
      "https://www.ethiopianairlines.com/aa/information/essential-information/conditions-of-carriage",
  },
  {
    name: "Etihad Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EY.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/EY.svg",
    id: "arl_00009VME7DC2bj9quHXKoY",
    iata_code: "EY",
    conditions_of_carriage_url:
      "https://www.etihad.com/en-gb/legal/conditions-of-carriage",
  },
  {
    name: "Euroairlines SL",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000AOnLULhHSZlbzXx8dl",
    iata_code: "Q4",
    conditions_of_carriage_url: null,
  },
  {
    name: "EuroAtlantic Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/YU.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/YU.svg",
    id: "arl_0000AOnLULhHSZlbzXx8dv",
    iata_code: "YU",
    conditions_of_carriage_url: null,
  },
  {
    name: "Eurocypria Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/UI.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/UI.svg",
    id: "arl_00009VME7DC2bj9quHXKoa",
    iata_code: "UI",
    conditions_of_carriage_url: null,
  },
  {
    name: "Eurofly Service",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/GJ.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/GJ.svg",
    id: "arl_00009VME7DC2bj9quHXKob",
    iata_code: "GJ",
    conditions_of_carriage_url: null,
  },
  {
    name: "Euroline",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEATorL0sX28f",
    iata_code: "4L",
    conditions_of_carriage_url: null,
  },
  {
    name: "Eurolot",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DC2bj9quHXKoc",
    iata_code: "K2",
    conditions_of_carriage_url: null,
  },
  {
    name: "European Air Express",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DC2bj9quHXKoe",
    iata_code: "EA",
    conditions_of_carriage_url: null,
  },
  {
    name: "EuropeSky",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/ES.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/ES.svg",
    id: "arl_00009VME7DEATorL0sX28n",
    iata_code: "ES",
    conditions_of_carriage_url: null,
  },
  {
    name: "Eurowings",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EW.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/EW.svg",
    id: "arl_00009VME7DC2bj9quHXKoh",
    iata_code: "EW",
    conditions_of_carriage_url:
      "https://www.eurowings.com/en/legal-information/general-conditions-of-carriage.html",
  },
  {
    name: "Eurowings Discover",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/4Y.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/4Y.svg",
    id: "arl_0000A9mGRng0IZQrzbxYp6",
    iata_code: "4Y",
    conditions_of_carriage_url:
      "https://discover.aero/en/general-terms-conditions-conditions-of-carriage-for-passengers-and-baggage-flight-ticket-gcc/",
  },
  {
    name: "Eurowings Europe",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000APtou54ZCGQ8ZUcgOu",
    iata_code: "E2",
    conditions_of_carriage_url:
      "https://www.eurowings.com/en/legal-information/general-conditions-of-carriage.html",
  },
  {
    name: "EVA Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/BR.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/BR.svg",
    id: "arl_00009VME7DC2bj9quHXKoH",
    iata_code: "BR",
    conditions_of_carriage_url:
      "https://www.evaair.com/en-us/website-disclaimer/conditions-of-carriage/",
  },
  {
    name: "Evergreen International Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EZ.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/EZ.svg",
    id: "arl_00009VME7DC2bj9quHXKoi",
    iata_code: "EZ",
    conditions_of_carriage_url: null,
  },
  {
    name: "Ewa Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/ZD.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/ZD.svg",
    id: "arl_0000APvixrM9vNxbmTBqfA",
    iata_code: "ZD",
    conditions_of_carriage_url:
      "https://ewa-air.com/en/conditions-of-carriage.html",
  },
  {
    name: "Excel Airways",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DC2bj9quHXKoj",
    iata_code: "JN",
    conditions_of_carriage_url: null,
  },
  {
    name: "ExpressJet",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DAch01WpssCcQ",
    iata_code: "EV",
    conditions_of_carriage_url: null,
  },
  {
    name: "ExpressJet",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/XE.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/XE.svg",
    id: "arl_00009VME7DC2bj9quHXKoo",
    iata_code: "XE",
    conditions_of_carriage_url: null,
  },
  {
    name: "ExpressJet Airlines as United Express",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009khl1XsNL7OhtKdJ3I",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "Express One International",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EO.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/EO.svg",
    id: "arl_00009VME7DC2bj9quHXKon",
    iata_code: "EO",
    conditions_of_carriage_url: null,
  },
  {
    name: "Far Eastern Air Transport",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DC2bj9quHXKoq",
    iata_code: "EF",
    conditions_of_carriage_url: null,
  },
  {
    name: "Fastjet Zimbabwe",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/FN.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/FN.svg",
    id: "arl_0000AOnLULhHSZlbzXx8dc",
    iata_code: "FN",
    conditions_of_carriage_url:
      "https://www.fastjet.com/upload/Documents/Terms%20and%20Conditions/fastjet%20Terms%20and%20Conditions%20-%20Feb%202019%20(1).pdf",
  },
  {
    name: "Federal Air",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000AOnLULhHSZlbzXx8dT",
    iata_code: "7V",
    conditions_of_carriage_url: null,
  },
  {
    name: "Fiji Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/FJ.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/FJ.svg",
    id: "arl_00009VME7DAyfgJ6qz2UAM",
    iata_code: "FJ",
    conditions_of_carriage_url:
      "https://www.fijiairways.com/en-gb/conditions-of-carriage",
  },
  {
    name: "Finnair",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AY.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AY.svg",
    id: "arl_00009VME7DC2bj9quHXKow",
    iata_code: "AY",
    conditions_of_carriage_url:
      "https://www.finnair.com/gb-en/info/conditions-of-carriage-and-notices/general-conditions-of-carriage-for-passengers-and-baggage",
  },
  {
    name: "Finnair as British Airways",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000AJ72a5lw08Q9b8ah9c",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "Finncomm Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/FC.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/FC.svg",
    id: "arl_00009VME7DC2bj9quHXKox",
    iata_code: "FC",
    conditions_of_carriage_url:
      "https://www.linkairways.com/about-us/conditions-of-carriage",
  },
  {
    name: "Firefly",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/FY.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/FY.svg",
    id: "arl_00009VME7DC2bj9quHXKoy",
    iata_code: "FY",
    conditions_of_carriage_url: null,
  },
  {
    name: "First Air",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000AOnLULhHSZlbzXx8dR",
    iata_code: "7F",
    conditions_of_carriage_url: null,
  },
  {
    name: "First Choice Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/DP.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/DP.svg",
    id: "arl_00009VME7DC2bj9quHXKoz",
    iata_code: "DP",
    conditions_of_carriage_url: null,
  },
  {
    name: "FlexFlight",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/W2.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/W2.svg",
    id: "arl_0000AOgijaLaGWNM1aaSZM",
    iata_code: "W2",
    conditions_of_carriage_url: null,
  },
  {
    name: "Flightline",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/B5.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/B5.svg",
    id: "arl_00009VME7DC2bj9quHXKp1",
    iata_code: "B5",
    conditions_of_carriage_url: null,
  },
  {
    name: "Florida West International Airways",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DC2bj9quHXKp3",
    iata_code: "RF",
    conditions_of_carriage_url: null,
  },
  {
    name: "Fly540",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/5H.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/5H.svg",
    id: "arl_00009VME7DEATorL0sX28C",
    iata_code: "5H",
    conditions_of_carriage_url: null,
  },
  {
    name: "Flybe",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DC2bj9quHXKpA",
    iata_code: "BE",
    conditions_of_carriage_url: null,
  },
  {
    name: "Fly Brasil",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEWSV8v1yhJg0",
    iata_code: "F1",
    conditions_of_carriage_url: null,
  },
  {
    name: "flydubai",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/FZ.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/FZ.svg",
    id: "arl_00009zhD2vOkfRg7hSzj4S",
    iata_code: "FZ",
    conditions_of_carriage_url:
      "https://www.flydubai.com/en/information/policies/conditions-of-carriage",
  },
  {
    name: "Flyglobespan",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/B4.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/B4.svg",
    id: "arl_00009VME7DC2bj9quHXKpB",
    iata_code: "B4",
    conditions_of_carriage_url: null,
  },
  {
    name: "FlyLal",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/TE.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/TE.svg",
    id: "arl_00009VME7DC2bj9quHXKp7",
    iata_code: "TE",
    conditions_of_carriage_url: null,
  },
  {
    name: "Flynas",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/XY.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/XY.svg",
    id: "arl_00009VME7DD6Xm0axa2BTG",
    iata_code: "XY",
    conditions_of_carriage_url:
      "https://static.flynas.com/images/terms_and_conditions/EN-TERMS-AND-CONDITIONS-OF-CARRIAGE-21Jun2022-V26.pdf",
  },
  {
    name: "Fly One",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/5F.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/5F.svg",
    id: "arl_0000AOtmceqii2X7Rse1CL",
    iata_code: "5F",
    conditions_of_carriage_url:
      "https://flyone.eu/en/About-FLYONE/General-Rules",
  },
  {
    name: "Fly Pelican",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/FP.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/FP.svg",
    id: "arl_0000AG86Tb1FfbD3olpHl2",
    iata_code: "FP",
    conditions_of_carriage_url: null,
  },
  {
    name: "French bee",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/BF.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/BF.svg",
    id: "arl_00009VME7DBKeMags5Cl16",
    iata_code: "BF",
    conditions_of_carriage_url: null,
  },
  {
    name: "Frontier Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/F9.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/F9.svg",
    id: "arl_00009VME7DC2bj9quHXKpE",
    iata_code: "F9",
    conditions_of_carriage_url: null,
  },
  {
    name: "Frontier Flying Service",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DC2bj9quHXKpF",
    iata_code: "2F",
    conditions_of_carriage_url: null,
  },
  {
    name: "Gabon Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/GY.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/GY.svg",
    id: "arl_00009VME7DEATorL0sX28G",
    iata_code: "GY",
    conditions_of_carriage_url: null,
  },
  {
    name: "Gadair European Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/GP.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/GP.svg",
    id: "arl_00009VME7DEATorL0sX28h",
    iata_code: "GP",
    conditions_of_carriage_url:
      "https://back-apgairlines.orchestra-platform.com/admin/TS/fckUserFiles/Content_File/carriage_conditions_APGAirlines_EN.pdf",
  },
  {
    name: "Garuda Indonesia",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/GA.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/GA.svg",
    id: "arl_00009VME7DC2bj9quHXKpL",
    iata_code: "GA",
    conditions_of_carriage_url:
      "https://www.garuda-indonesia.com/uk/en/contact/condition-of-carriage",
  },
  {
    name: "Gazpromavia",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/4G.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/4G.svg",
    id: "arl_00009VME7DC2bj9quHXKpM",
    iata_code: "4G",
    conditions_of_carriage_url: null,
  },
  {
    name: "GB Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/GT.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/GT.svg",
    id: "arl_00009VME7DC2bj9quHXKpH",
    iata_code: "GT",
    conditions_of_carriage_url: null,
  },
  {
    name: "Georgian Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/A9.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/A9.svg",
    id: "arl_00009VME7DC2bj9quHXKpO",
    iata_code: "A9",
    conditions_of_carriage_url:
      "https://www.georgian-airways.com/en/information/conditions",
  },
  {
    name: "Georgian National Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QB.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QB.svg",
    id: "arl_00009VME7DC2bj9quHXKpP",
    iata_code: "QB",
    conditions_of_carriage_url: null,
  },
  {
    name: "German Airways for BA CityFlyer",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DBgd2sGtBN3JP",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "Germania",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DC2bj9quHXKpQ",
    iata_code: "ST",
    conditions_of_carriage_url: null,
  },
  {
    name: "Germanwings",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DC2bj9quHXKpR",
    iata_code: "4U",
    conditions_of_carriage_url: null,
  },
  {
    name: "Ghana International Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DC2bj9quHXKpT",
    iata_code: "G0",
    conditions_of_carriage_url: null,
  },
  {
    name: "Go First",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/G8.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/G8.svg",
    id: "arl_00009VME7DC2bj9quHXKpU",
    iata_code: "G8",
    conditions_of_carriage_url: null,
  },
  {
    name: "GoJet Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DC2bj9quHXKpV",
    iata_code: "G7",
    conditions_of_carriage_url: null,
  },
  {
    name: "GoJet Airlines as United Express",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009khl04Tl9SdWQdPrY8",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "GOL",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/G3.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/G3.svg",
    id: "arl_00009VME7DC2bj9quHXKpW",
    iata_code: "G3",
    conditions_of_carriage_url:
      "https://www.voegol.com.br/en-us/legal-information/passenger-air-transportation-agreement",
  },
  {
    name: "Golden Air",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DC2bj9quHXKpX",
    iata_code: "DC",
    conditions_of_carriage_url: null,
  },
  {
    name: "Great Lakes Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DC2bj9quHXKpa",
    iata_code: "ZK",
    conditions_of_carriage_url: null,
  },
  {
    name: "Gulf Air Bahrain",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/GF.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/GF.svg",
    id: "arl_00009VME7DCOaPRQvNhcMT",
    iata_code: "GF",
    conditions_of_carriage_url:
      "https://www.gulfair.com/transparency/conditions-of-carriage",
  },
  {
    name: "Hageland Aviation Services",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/H6.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/H6.svg",
    id: "arl_00009VME7DCOaPRQvNhcMU",
    iata_code: "H6",
    conditions_of_carriage_url: null,
  },
  {
    name: "Hahn Air",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/HR.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/HR.svg",
    id: "arl_00009VME7DCOaPRQvNhcMV",
    iata_code: "HR",
    conditions_of_carriage_url:
      "https://www.hahnair.com/en/terms-and-conditions-ticketing",
  },
  {
    name: "Hahn Air Systems",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/H1.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/H1.svg",
    id: "arl_00009zkCNzEm4WdxCxgdog",
    iata_code: "H1",
    conditions_of_carriage_url: null,
  },
  {
    name: "Hainan Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/HU.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/HU.svg",
    id: "arl_00009VME7DCOaPRQvNhcMW",
    iata_code: "HU",
    conditions_of_carriage_url:
      "https://www.hainanairlines.com/HUPortal/dyn/portal/DisplayPage?LANGUAGE=GB&COUNTRY_SITE=GB&SITE=CBHZCBHZ&PAGE=TECO",
  },
  {
    name: "Hamburg International",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DCOaPRQvNhcMX",
    iata_code: "4R",
    conditions_of_carriage_url: null,
  },
  {
    name: "Hankook Airline",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEWSV8v1yhJgB",
    iata_code: "HN",
    conditions_of_carriage_url: null,
  },
  {
    name: "Hapagfly",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/HF.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/HF.svg",
    id: "arl_00009VME7DCOaPRQvNhcMZ",
    iata_code: "HF",
    conditions_of_carriage_url: null,
  },
  {
    name: "Hawaiian Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/HA.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/HA.svg",
    id: "arl_00009VME7DCOaPRQvNhcMc",
    iata_code: "HA",
    conditions_of_carriage_url:
      "https://www.hawaiianairlines.com/legal/international-contract-of-carriage",
  },
  {
    name: "Heli Air Monaco",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000AOnLULhHSZlbzXx8du",
    iata_code: "YO",
    conditions_of_carriage_url: null,
  },
  {
    name: "Heli France",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/8H.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/8H.svg",
    id: "arl_00009VME7DCOaPRQvNhcMe",
    iata_code: "8H",
    conditions_of_carriage_url: null,
  },
  {
    name: "Helijet",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DCOaPRQvNhcMf",
    iata_code: "JB",
    conditions_of_carriage_url: null,
  },
  {
    name: "Hellas Jet",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DCOaPRQvNhcMh",
    iata_code: "T4",
    conditions_of_carriage_url: null,
  },
  {
    name: "Hellenic Imperial Airways",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DEATorL0sX28b",
    iata_code: "HT",
    conditions_of_carriage_url: null,
  },
  {
    name: "Hello",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/HW.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/HW.svg",
    id: "arl_00009VME7DCOaPRQvNhcMi",
    iata_code: "HW",
    conditions_of_carriage_url: null,
  },
  {
    name: "Helvetic Airways",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/2L.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/2L.svg",
    id: "arl_00009VME7DCOaPRQvNhcMj",
    iata_code: "2L",
    conditions_of_carriage_url: "https://www.helvetic.com/en/travelinfo",
  },
  {
    name: "Hex'Air",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DCOaPRQvNhcMm",
    iata_code: "UD",
    conditions_of_carriage_url: null,
  },
  {
    name: "Himalaya Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/H9.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/H9.svg",
    id: "arl_0000AOtmceqii2X7Rse1Cf",
    iata_code: "H9",
    conditions_of_carriage_url:
      "https://www.himalaya-airlines.com/travel-ha/general-conditions-of-carriage",
  },
  {
    name: "Himalayan Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/HC.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/HC.svg",
    id: "arl_00009VME7DEWSV8v1yhJg2",
    iata_code: "HC",
    conditions_of_carriage_url:
      "https://flyairsenegal.com/en/legal-notice/conditions-of-carriage/",
  },
  {
    name: "HK Express",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/UO.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/UO.svg",
    id: "arl_00009VME7DCOaPRQvNhcMr",
    iata_code: "UO",
    conditions_of_carriage_url:
      "https://www.hkexpress.com/en-hk/need-help/conditions-of-carriage/",
  },
  {
    name: "Hong Kong Airlines",
    logo_symbol_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/HX.svg",
    logo_lockup_url:
      "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/HX.svg",
    id: "arl_00009VME7DCOaPRQvNhcMq",
    iata_code: "HX",
    conditions_of_carriage_url:
      "https://www.hongkongairlines.com/en_HK/footer/legal-privacy/home",
  },
  {
    name: "Horizon Air",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009VME7DCOaPRQvNhcMs",
    iata_code: "QX",
    conditions_of_carriage_url: null,
  },
  {
    name: "Horizon Air as Alaska Airlines",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_0000A7w6B5j6mqgTUONFxo",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
  {
    name: "Horizon Air as Alaska Horizon",
    logo_symbol_url: null,
    logo_lockup_url: null,
    id: "arl_00009khkxumEFjn1l71ijY",
    iata_code: null,
    conditions_of_carriage_url: null,
  },
];
export default airlinesList;
